import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import styles from '@features/footer/components/LanguageSelect/LanguageSelect.styles';
import theme from '@styles/theme';
import Icon from '@components/icons/Icon';
import { useSIteTypesStore } from '@features/footer/components/LanguageSelect/mobX/context/SiteTypesProvider';
import Button from '@components/Button/Button';
import { useRouter } from 'next/router';
import LanguageDropdown from './LanguageDropdown/LanguageDropdown';
const DynamicLanguageSideBar = dynamic(() => import('@features/footer/components/LanguageSelect/LanguageSideBar/LanguageSideBar'), {
  ssr: false
});
const LanguageSelect = () => {
  const {
    t
  } = useTranslation('layouts');
  const {
    locale
  } = useRouter();
  const {
    openSidebar,
    initializeData,
    selectedLanguage,
    selectedSiteType,
    setDefultLanguage
  } = useSIteTypesStore();
  const [isDropdownExpanded, setIsDropdownExpanded] = useState(false);
  const [selectedLanguageName, setSelectedLanguageName] = useState<string | null>(selectedLanguage?.name || null);
  useEffect(() => {
    (async () => {
      await initializeData();
      setSelectedLanguageName(setDefultLanguage(locale)?.name || null);
    })();
  }, [locale]);
  return <div sx={styles.languageSelect}>
      <DynamicLanguageSideBar />
      <span sx={styles.languageSelectIcon}>
        <Icon icon="Language" size="24px" color={theme.rawColors.darkGrey700} />
      </span>
      <div sx={styles.languageSelectTextWrapper}>
        <button type="button" onClick={() => {
        setIsDropdownExpanded(false);
        openSidebar();
      }} sx={styles.languageSelectUnderlineText(false)}>
          {t('footer.changeRegion')}
        </button>
        {selectedLanguageName && <>
            <span> /&nbsp;</span>
            <Button variant="iconOnly" addSx={styles.expandMoreIcon(isDropdownExpanded)} onClick={() => setIsDropdownExpanded(prev => !prev)}>
              <span sx={styles.languageSelectUnderlineText(true)}> {` ${selectedLanguageName}`}</span>
              <Icon icon="ExpandMore" size="24px" />
            </Button>
          </>}
      </div>
      {selectedSiteType && selectedSiteType?.languages?.length > 0 && <div sx={styles.dropdown(isDropdownExpanded)}>
          <LanguageDropdown availableLanguages={selectedSiteType?.languages} onClose={() => setIsDropdownExpanded(false)} />
        </div>}
    </div>;
};
export default LanguageSelect;